<script>
    import Question from "./Question.svelte";
    import SubmitButton from "./interface/SubmitButton.svelte";
    import DevTools from "./interface/DevTools.svelte";
    import interface_element_translations from "./interface/interface_element_translations.json";

    export let question_set;
    export let user_language;
    export let current_question_set_idx;
    export let is_first_question_set = false;
    export let is_last_question_set = false;

    export let is_active = false;

    // is the form currently submitting? (This is set by an event on the parent form [in Survey.svelte])
    export let submitting = false;

    export let responses;

    export let enable_debug = false;
    export let show_responses = false; // for debugging: show all responses
    let questionset_id = question_set["questionset_id"];

    let set_is_complete = false;
    let survey_is_complete = false;

    // TODO: there's got to be a more spiffy, functional way to do this
    // check if every item has a non-empty response
    function check_survey_complete() {
        let complete = true;
        Object.values(responses).forEach((questionset) => {
            if (Object.values(questionset).some((q) => q.length == 0)) {
                complete = false;
            }
        });

        return complete;
    }

    function check_set_complete() {
        set_is_complete = !Object.values(
            responses[question_set["questionset_id"]],
        ).some((x) => x === null || (typeof x === "string" && x.trim() === ""));
        survey_is_complete = check_survey_complete();
    }

    let preamble = "";

    // randomly present questions within a set (except for initial "usertags" identifiers)
    if (questionset_id !== "usertags") {
        question_set.questions.sort(() => Math.random() - 0.5);
    }

    $: if (question_set["preamble"]) {
        preamble = question_set["preamble"][user_language];
    }

    // if all questions in this set have responses, we can move on
    $: responses, check_set_complete();
</script>

<div class="question_set" class:active={is_active}>
    {#if enable_debug}
        <DevTools
            bind:responses
            bind:questionset_id
            bind:current_question_set_idx
            bind:is_last_question_set
            bind:show_responses
        />
    {/if}

    <blockquote>
        {@html preamble}
    </blockquote>

    <div class="questions">
        {#each Object.entries(question_set["questions"]) as [_, question]}
            <Question
                {questionset_id}
                {question}
                {user_language}
                bind:responses
            />
        {/each}
    </div>
    <div class="actions">
        <div class="last">
            <button
                type="button"
                on:click={() => current_question_set_idx--}
                style:visibility={is_first_question_set ? "hidden" : ""}
                >{interface_element_translations["back"][user_language]}</button
            >
        </div>
        <div class="next">
            <button
                type="button"
                on:click={() => current_question_set_idx++}
                style:visibility={is_last_question_set ? "hidden" : ""}
                disabled={!set_is_complete}
                >{interface_element_translations["next"][user_language]}</button
            >
        </div>
        <div class="submit">
            <SubmitButton {survey_is_complete} {submitting} {user_language} />
        </div>
    </div>
</div>

<style lang="scss">
    .question_set {
        /* hide unless class="active" */
        display: none;
        margin: 0 2em;
    }

    blockquote {
        margin-bottom: 2em;
    }
    .questions {
        width: fit-content;
        margin: 0 auto;
    }

    .active {
        display: block;
    }

    .actions {
        display: flex;
        flex-direction: row;
        margin: 2em;
        .last {
            flex-grow: 1;
            text-align: left;
            margin-left: 8em;
        }
        .next {
            flex-grow: 1;
            text-align: right;
        }
        .submit {
            width: 8em;
            text-align: center;
        }
    }
</style>
